import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { WalletContext } from "../WalletProvider";
import "../../../css/wallet/Token/Token.css";
import { useTranslation } from "react-i18next";
import SendToken from "./SendToken";
import { TokenRequest } from "./TokenRequest";
import ReceiveToken from "./ReceiveToken";
import TomanDeposit from "../Toman/TomanDepost";
import TomanWithdrawal from "../Toman/TomanWithdrawal";
import { AuthContext } from "../../SessionChecker/SessionChecker";

function Token({ theme }) {
  const { token } = useParams();
  const { tokensInfo, btcAPIData, trxAPIData, tomanAPI, gramAPIData, bnbAPIData } =
    useContext(WalletContext);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [tokenAddress, setTokenAddress] = useState("");

  const [receiveStatus, setReceiveStatus] = useState(false);
  const [sendStatus, setSendStatus] = useState(false);
  const [depositStatus, setDepositStatus] = useState(false);
  const [withdrawalStatus, setWithdrawalStatus] = useState(false);

  const { sessionStatus } = useContext(AuthContext);

  const [data, setData] = useState(false);

  useEffect(() => {
    TokenRequest(token, setData);

  }, [receiveStatus, btcAPIData, trxAPIData]); 

  return (
    <div className="mainDiv"> 
      <div className={`headerDiv ${theme}`}>{t(token.toUpperCase())}</div>

      <div className="contentDiv">
        {sessionStatus && (
          <div className="tokenBalanceDivFromToken">
            {data[0]?.balance.toLocaleString('en-US')}
          </div>
        )}

        {sessionStatus && (
          <div className="tokenValueBalanceFromToken">
            {data[0]?.value?.toLocaleString('en-US')}

          </div>
        )}

        <div className={`tokenChangeDivFromToken`}>
        </div>

        {sessionStatus && (
          <div className="tokenButtonsDiv">
            
              <div className="tokenButtonsDiv2">
                <button
                  className="tokenButton"
                  onClick={() => {
                    setDepositStatus(true);
                  }}
                >
                  <img src="/icons/deposit.png" className={`${theme}`}></img>
                  <div>{t("Deposit")}</div>
                </button>
                <button
                  className="tokenButton"
                  onClick={() => {
                    setWithdrawalStatus(true);
                  }} 
                >
                  <img src="/icons/withdrawal.png"></img>
                  <div>{t("Withdrawal")}</div>
                </button>

              </div>

          </div>
        )}

        {receiveStatus && (
          <ReceiveToken
            theme={theme}
            setReceiveStatus={setReceiveStatus}
            token={token}
          ></ReceiveToken>
        )}

        {sendStatus && (
          <SendToken
            theme={theme}
            setSendStatus={setSendStatus}
            token={token}
          ></SendToken>
        )}

        {depositStatus && (
          <TomanDeposit
            theme={theme}
            setDepositStatus={setDepositStatus}
            token={token}
            data={data}
          ></TomanDeposit>
        )}

        {withdrawalStatus && (
          <TomanWithdrawal
            theme={theme}
            setWithdrawalStatus={setWithdrawalStatus}
            token={token}
          ></TomanWithdrawal>
        )}


      </div>
    </div>
  );
}

export default Token;
